/**
 * The shell's words for a screen drawn from the copy kept on this device while the server cannot be
 * reached (`source.offline_read`, docs/design/offline-outbox.md §4). Kept beside the catalogue and
 * spread into it, like the renderer's.
 */
export const OFFLINE_EN = {
    'shell.offline.asOf': 'Offline — shown as it was at {when}; it may be out of date.',
    'shell.offline.held': 'Not available offline. It works again once you are back online.',
    'shell.offline.choices': 'Offline — the choices are as they were at {when}; they may be out of date.',
};
export const OFFLINE_AR = {
    'shell.offline.asOf': 'غير متصل، معروض كما كان في {when}، وقد لا يكون محدَّثاً.',
    'shell.offline.held': 'غير متاح دون اتصال، ويعمل حين يعود الاتصال.',
    'shell.offline.choices': 'غير متصل، الخيارات كما كانت في {when}، وقد لا تكون محدَّثة.',
};
//# sourceMappingURL=i18n-offline.js.map